import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { environment } from '@env/environment.prod';
import { Paginated } from '../model/paginated.model';
import { Observable } from 'rxjs';
import { Client } from '../model/client.model';

@Injectable({
  providedIn: 'root'
})
export class PagoIngresoService extends BaseAPIClass {
  // baseUrl = environment.serverBaseUrl;
  baseUrl = environment.serverBaseUrl;
  public isLoading = false;
  constructor(protected httpClient: HttpClient, handler: HttpBackend) {
    super(httpClient);
    this.httpClient = new HttpClient(handler);
    this.baseUrl = this.baseUrl + '/pago-ingresos';
  }

  /*enableClient(id: any) {

  }*/

  buscarTotal(id: any): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + '/comprobante/' + id);
  }

  listarPagos(id: string, producto_id: any, proveedor_id: any) {
    return this.httpClient.get(
      this.baseUrl +
        '?nro_comprobante=' +
        id +
        '&producto_id=' +
        producto_id +
        '&proveedor_id=' +
        proveedor_id
    );
  }

  search(term: string): Promise<Paginated> {
    this.isLoading = true;
    const url2 = this.baseUrl + '/' + term;
    return this.httpClient
      .get(url2)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }
  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    // this.isLoading = false;
    return Promise.reject(error.message || error);
  }

  getVentasAtUrl(url: string): Promise<Paginated> {
    this.isLoading = true;
    return this.httpClient
      .get(url)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  pdfPogoIngreso(id:any):Observable<any>{
    return this.httpClient.get(this.baseUrl+'/pdf?nro_comprobante='+id, {
      responseType: 'blob'
    });
  }

}
